import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectDirectoryFetchFailedAction = {
	type: 'SUBJECT_DIRECTORY_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectDirectoryFetchFailedAction => ({
	type: 'SUBJECT_DIRECTORY_FETCH_FAILED',
	payload,
});
